import React, { useCallback, useEffect, useMemo, } from "react";
import { FormWrapper, } from "../../components/styles";
import { Form, FormInstance, Input, Select } from "antd";
import { FormItemLabel, TrackingNumberContainer, UploadInfoText } from "../styles";
import { useAppDispatch, useAppSelector } from "../../utils/hooks/redux";
import { RequestResults } from "../../redux/common/RequestStatus";
import { selectCourier } from "../../redux/features/courier/courierSlice";
import { fetchCouriers } from "../../redux/features/courier/courierAsyncThunk";
import { PaymentStatus } from "../../types";
import { selectUserRole } from "../../redux/features/auth/selectors";
import { checkHasPermission } from "../../utils/helpers/checkHasPermission";
import { permissions } from "../../utils/constants/permissions";

type TrackingNumberProps = {
    form: FormInstance;
    loading: boolean;
};

const TrackingNumber: React.FC<TrackingNumberProps> = ({ form, loading }) => {
    const dispatch = useAppDispatch();
    const { report } = useAppSelector((state) => state.report);

    const { data: couriers, status: courierStatus, loading: courierLoading } = useAppSelector(selectCourier);
    const userRole = useAppSelector(selectUserRole);

    const hasPermission = useCallback(
        (permissionKey: string) => checkHasPermission(userRole, permissionKey),
        [userRole]
    );

    const selectedCourier = useMemo(() => report?.payment?.find((payment) => payment.status === PaymentStatus.Succeeded)?.shippingOption?.courier, [report]);

    const isAddPermission = useMemo(() => hasPermission(permissions.AddEditTrackingDocs), [hasPermission]);
    const isEditPermission = useMemo(() => hasPermission(permissions.AddEditTrackingDocs), [hasPermission]);
    const isDeletePermission = useMemo(() => hasPermission(permissions.DeleteTrackingDocs), [hasPermission]);


    useEffect(() => {
        if (courierStatus === RequestResults.idle) {
            dispatch(fetchCouriers({}));
        }
    }, [dispatch, courierStatus]);


    const trackingOptions = useMemo(() => {
        return couriers?.map((courier) => ({
            label: courier.name,
            value: courier.id,
            key: courier.id,
        }));
    }, [couriers]);

    useEffect(() => {
        if (selectedCourier) {
            form.setFieldValue("courier", selectedCourier.id);
        }
        form.setFieldValue("trackingNumber", report?.trackingNumber);
    }, [selectedCourier, form, report?.trackingNumber, report]);


    return (
        <TrackingNumberContainer>
            <FormWrapper form={form} layout="vertical" disabled={loading}>
                <FormItemLabel>* Tracking Number</FormItemLabel>
                {(isAddPermission || isEditPermission) && <UploadInfoText color="#FF4D4F">Check your uploaded shipping label and enter the tracking number here</UploadInfoText>}
                <Form.Item label={isAddPermission || isEditPermission ? "Select Courier" : "Courier"} name="courier" rules={[{ required: true, message: "Please Select Courier required" }]}>
                    <Select loading={courierLoading} size="large" disabled={!!selectedCourier} options={trackingOptions} placeholder="Select Courier" />
                </Form.Item>
                <Form.Item label="Tracking Number" name="trackingNumber" rules={[{ required: true, message: "Please Enter Tracking Number" }]}>
                    <Input size="large" placeholder="Tracking Number" disabled={!(isAddPermission || isEditPermission)} />
                </Form.Item>
            </FormWrapper>
        </TrackingNumberContainer>
    );
};

export default TrackingNumber;